import { mainPalette as palette } from './palettes';

export default {
  h1: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px'
  },
  h2: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '29px',
    letterSpacing: '-0.24px',
    lineHeight: '32px'
  },
  h3: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px'
  },
  h4: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '20px',
    '@media (max-width:350px)': {
      fontSize: '14px',
    },
    letterSpacing: '-0.06px',
    lineHeight: '24px'
  },
  h5: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  h6: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    '@media (max-width:350px)': {
      fontSize: '12px',
      lineHeight: '12px'
    },
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  subtitle1: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px'
  },
  subtitle2: {
    color: palette.text.secondary,
    fontFamily: '"Lato", sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px'
  },
  body1: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '16px'
  },
  body2: {
    color: palette.text.secondary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '12px',
    letterSpacing: '-0.04px',
    lineHeight: '18px'
  },
  button: {
    color: palette.text.primary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '14px'
  },
  caption: {
    color: palette.text.secondary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px'
  },
  overline: {
    color: palette.text.secondary,
    fontFamily: '"Lato", sans-serif',
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px',
    textTransform: 'uppercase'
  }
};
